import { $, $all, toArray, listenResize } from "@olmokit/dom";
import { breakpoints, gridGutter } from "@olmokit/core/scss";
import {
  glide,
  Swipe,
  Anchors,
  Autoplay,
  Controls,
  Breakpoints,
  LazyLoad,
} from "@olmokit/core/glide";
import "utils/slider-controls.scss";
import "components/Card/Video";
import "./index.scss";

/**
 * Component: Slider design
 *
 * @param {string} rootSelector
 */
export default function SliderVideos(rootSelector) {
  const $slider = $(`${rootSelector} .SliderVideos:`);
  let isSlider = false;

  if (!$slider) {
    return;
  }

  const count = toArray($all(".glide__slide", $slider)).length;
  const slider = glide($slider, {
    // loop: false,
    autoplay: 3500,
    animationDuration: 1000,
    // rewind: true,
    // rewindDuration: 1000,
    gap: gridGutter,
    bound: true,
    perView: 3,
    breakpoints: {
      [breakpoints.lg]: {
        perView: 3,
        peek: { before: gridGutter * 1.5, after: gridGutter * 2 },
      },
      [760]: {
        perView: 2,
        peek: { before: gridGutter * 1.5, after: gridGutter * 2 },
      },
      450: {
        perView: 1,
        peek: { before: gridGutter * 1.5, after: gridGutter * 2 },
      },
    },
  });

  function handleResize() {
    const should = shouldItBeAslider(window.innerWidth);
    if (!isSlider && should) {
      // slider.enable();
      slider.mount({ Swipe, Anchors, Autoplay, Controls, Breakpoints, LazyLoad });
      isSlider = true;
    }
    if (isSlider && !should) {
      // slider.disable();
      slider.destroy();
      isSlider = false;
    }
  }

  function shouldItBeAslider(winWidth) {
    if (winWidth > breakpoints.lg) {
      if (count > 3) {
        return true;
      }
      return false;
    } else if (winWidth > 760) {
      if (count > 2) {
        return true;
      }
      return false;
    }
    if (count > 1) {
      return true;
    }
    return false;
  }

  // slider.mount({ Swipe, Anchors, Controls, Breakpoints, LazyLoad })

  handleResize();
  listenResize(handleResize);
}
